/**
 * resolveChildName — normaliserar barnets förnamn till ett tilltalsnamn som
 * kompanjonen kan använda i sina repliker.
 *
 * Namnet kommer från User.firstName (AppContext) — INTE från characterName i
 * CharacterContext, som är kompisens eget namn.
 *
 * Regler (NPF-motiverade, Chiron):
 *  1. Trimma. Tom sträng ⇒ null (ingen tilltalsvariant).
 *  2. Använd första whitespace-separerade token ("Elsa Maria" ⇒ "Elsa").
 *  3. Kräv minst en bokstav — annars null.
 *  4. Längdtak 15 tecken. Över taket ⇒ null. TRUNKERA ALDRIG (ett halvt namn
 *     är värre än inget namn).
 *  5. Använd namnet exakt som lagrat. Enda undantaget: helt gemena token får
 *     versal begynnelsebokstav ("elsa" ⇒ "Elsa"). Namn med versal någonstans
 *     ("McKay", "deSousa") rörs aldrig.
 *
 * null betyder "visa den namnlösa repliken" — aldrig en tom interpolationsslot.
 */

/** Längdtak för tilltalsnamnet. Längre namn ger null i stället för trunkering. */
const MAX_NAME_LENGTH = 15;

const HAS_LETTER = /\p{L}/u;

export const resolveChildName = (firstName?: string | null): string | null => {
  const trimmed = (firstName ?? '').trim();
  if (trimmed.length === 0) {
    return null;
  }

  const [token] = trimmed.split(/\s+/);
  if (!token || token.length === 0 || token.length > MAX_NAME_LENGTH) {
    return null;
  }
  if (!HAS_LETTER.test(token)) {
    return null;
  }

  // Endast helt gemena namn versaliseras; allt annat lämnas orört.
  if (token === token.toLowerCase()) {
    return token.charAt(0).toUpperCase() + token.slice(1);
  }
  return token;
};
